import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

type AdminOverrideCardAction = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
};

type AdminOverrideCardProps = {
  icon: LucideIcon;
  title: string;
  statusLabel: string;
  statusDescription: string;
  action?: AdminOverrideCardAction;
  children?: ReactNode;
};

/** Shared shell for a store detail page card that grants/revokes a single admin-only boolean override. */
export function AdminOverrideCard({
  icon: Icon,
  title,
  statusLabel,
  statusDescription,
  action,
  children,
}: AdminOverrideCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Icon className="size-4" /> {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">{statusLabel}</p>
            <p className="text-xs text-muted-foreground">{statusDescription}</p>
          </div>

          {action && (
            <Button variant="outline" size="sm" onClick={action.onClick} disabled={action.disabled}>
              {action.label}
            </Button>
          )}
        </div>

        {children}
      </CardContent>
    </Card>
  );
}
